import { render, staticRenderFns } from "./PowerTranslateView.vue?vue&type=template&id=397e25ba&scoped=true"
import script from "./PowerTranslateView.vue?vue&type=script&lang=js"
export * from "./PowerTranslateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e25ba",
  null
  
)

export default component.exports